import { useEffect, useState } from 'react'
import {
    useMapsLibrary,
    useMap,
} from "@vis.gl/react-google-maps"

function Directions({ originAddress, destinationAddress, isMobile}) {
    const map = useMap()
    const routesLibrary = useMapsLibrary("routes")
    const [directionsService, setDirectionsService] = useState()
    const [directionsRenderer, setDirectionsRenderer] = useState()
    const [routes, setRoutes] = useState([])
    const [routeIndex, setRouteIndex] = useState(0)
    const selected = routes[routeIndex]
    const leg = selected?.legs[0]

    useEffect(() => {
        if (!routesLibrary || !map) return
        setDirectionsService(new routesLibrary.DirectionsService())
        setDirectionsRenderer(new routesLibrary.DirectionsRenderer({ map }))
    }, [routesLibrary, map, originAddress, destinationAddress])

    useEffect(() => {
        if (!directionsService || !directionsRenderer) return

        directionsService
            .route({
                origin: originAddress,
                destination: destinationAddress,
                travelMode: "WALKING",
                provideRouteAlternatives: true
            })
            .then(response => {
                directionsRenderer.setDirections(response)
                setRoutes(response.routes)
            })

        return () => directionsRenderer.setMap(null)
    }, [originAddress, destinationAddress, directionsService, directionsRenderer])

    useEffect(() => {
        if (!directionsRenderer) return
        directionsRenderer.setRouteIndex(routeIndex)
    }, [routeIndex, directionsRenderer, originAddress, destinationAddress])

    if (!leg) return null
    if(isMobile)
        return 
    else{
        return (
            <div className="directions">
    
                <h2>{selected.summary}</h2>
                <p>
                    {leg.start_address.split(",")[0]} to {leg.end_address.split(",")[0]}
                </p>
                <p>Distance: {leg.distance?.text}</p>
                <p>Duration: {leg.duration?.text}</p>
    
                <h2>Other Routes</h2>
                <ul>
                    {routes.map((route, index) => (
                        <li key={route.summary}>
                            <button onClick={() => setRouteIndex(index)}>
                                {route.summary}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        )
    }
    
}

export default Directions;
